import { Box, Typography } from "@mui/material";
import { Plan, usePlanContext } from "./context/planContext";
import { handleSignUp } from "./utils";
import { useLocation, useNavigate } from "react-router-dom";
import { getCurrentPromoCode } from "../../utils/promoCodeUtils";
import {
  ComparisonWrapper,
  ComparisonHeaderContainer,
  ComparisonTitle,
  ComparisonTitleText,
  ComparisonArrow,
  ComparisonContent,
  ComparisonLeftColumn,
  ComparisonDescription,
  ComparisonSignUpButton,
  ComparisonRightColumn,
  ComparisonRow,
  ComparisonLogo,
  ComparisonBarContainer,
  ComparisonBar,
  ComparisonDashedLine,
  ComparisonPriceText,
  ComparisonPriceUnit,
  ComparisonPlanName,
  ComparisonDisclaimer,
} from "./styles/components";
import LoadingSkeleton from "./Skeleton/CompareLoadingSkeleton";
import { useState } from "react";
import { Comparison } from "../../types";
import ComparsionModal from "./ComparsionModal";
export default function ComparisonSection() {
  const {
    plans,
    zipCode,
    utility,
    comparePlansLoading,
    compareData,
    plansLoading,
    bestValuePlan,
  } = usePlanContext();
  const location = useLocation();
  const routeBasedPromoCode = getCurrentPromoCode(location.pathname);
  const navigate = useNavigate();
  const maxValue = Math.max(...compareData.map((c) => c.value));
  const [showComparisonCardModal, setShowComparisonCardModal] = useState(false);
  const [selectComparisonCardModal, setSelectComparisonCardModal] =
    useState<Comparison>();
  if (plansLoading) return null;

  const handleComparisonCardModal = (plan: Comparison) => {
    setShowComparisonCardModal(true);
    setSelectComparisonCardModal(plan);
  };
  const twelveMonthConstoPlan = plans.filter((p) => {
    return p?.plan_id === compareData[0]?.plan_id;
  })[0];


  return comparePlansLoading ? (
    <LoadingSkeleton />
  ) : (
    <>
      {compareData && compareData.length > 1 ? (
        <ComparisonWrapper id="comparison-section">
          <ComparisonContent>
            <ComparisonLeftColumn>
              <>
                <ComparisonHeaderContainer>
                  <ComparisonTitle>
                    <ComparisonTitleText>
                      Same Term, Lower Rate
                    </ComparisonTitleText>
                    {/* <ComparisonArrow src="/images/constenewImg/ei_arrow-right.svg" alt="arrow" /> */}
                  </ComparisonTitle>
                </ComparisonHeaderContainer>
                <Box
                  sx={{
                    display: "flex",
                    flexDirection: "column",
                    alignItems: "flex-start",
                    gap: "24px",
                    alignSelf: "stretch",
                    marginTop: { xs: "8px", md: "10px" },
                  }}
                >
                  <ComparisonDescription>
                    Constellation's {twelveMonthConstoPlan?.plan_name} Plan can
                    save you up to {twelveMonthConstoPlan?.savings} compared to
                    similar plans elsewhere.
                  </ComparisonDescription>
                  <Box>
                    <Typography sx={{ color: "#2372B9" }}>
                      {twelveMonthConstoPlan?.plan_name}
                    </Typography>
                    <ComparisonSignUpButton
                      variant="contained"
                      onClick={() => {
                        localStorage.setItem(
                          "selectProduct",
                          JSON.stringify(twelveMonthConstoPlan?.plan_name),
                        );
                        localStorage.setItem(
                          "utility",
                          JSON.stringify(utility),
                        );
                        localStorage.setItem("promoCode", routeBasedPromoCode);
                        handleSignUp(
                          twelveMonthConstoPlan as Plan,
                          zipCode,
                          utility,
                          navigate,
                          location,
                        );
                      }}
                    >
                      <Typography
                        sx={{
                          color: "#FFF",
                          fontFamily: "Inter",
                          fontSize: { xs: "14px", md: "16px" },
                          fontStyle: "normal",
                          fontWeight: 600,
                          lineHeight: "20px",
                          letterSpacing: "-0.15px",
                        }}
                      >
                        Select Plan
                      </Typography>
                    </ComparisonSignUpButton>
                  </Box>
                </Box>
              </>
            </ComparisonLeftColumn>
            <ComparisonRightColumn>
              <>
                {compareData.map((plan, idx) => {
                  const widthPercent = `${(plan.value / maxValue) * 85}%`;
                  const delay = 0.3 + idx * 0.3;
                  return (
                    <ComparisonRow key={idx}>
                      <Box
                        sx={{ display: "flex", alignItems: "center", gap: 1 }}
                      >
                        <ComparisonLogo
                          src={plan.logoSrc}
                          alt="brand"
                          grayscale={idx > 0}
                        />
                      </Box>
                      <ComparisonBarContainer>
                        <ComparisonBar
                          color={plan.color}
                          delay={delay}
                          width={widthPercent}
                        />
                        <ComparisonDashedLine />
                        <ComparisonPriceText>
                          {plan.value}
                          {plan.unit}
                          <ComparisonPriceUnit>per kWh</ComparisonPriceUnit>
                        </ComparisonPriceText>
                        <ComparisonPlanName style={{ width: "100%" }}>
                          <Box
                            sx={{
                              display: "flex",
                              justifyContent: "space-between",
                              gap: 0.5,
                              width: {xs:"100%", md:"576px"},
                            }}
                          >
                            <Box
                            sx={{cursor: "pointer"}}
                              onClick={() => handleComparisonCardModal(plan)}
                            >
                              {plan.plan_name}
                            </Box>

                          </Box>
                        </ComparisonPlanName>
                      </ComparisonBarContainer>
                    </ComparisonRow>
                  );
                })}
                <ComparisonDisclaimer>
                  The comparisons above are to companies that we believe meet
                  our standard of quality, and do not represent all plans
                  available from us or from the competitors listed. This is a
                  snapshot of plans as of {new Date().toLocaleDateString()} and
                  are subject to change based on market conditions and provider
                  offerings.
                </ComparisonDisclaimer>
              </>
            </ComparisonRightColumn>
          </ComparisonContent>
        </ComparisonWrapper>
      ) : null}

      {showComparisonCardModal && selectComparisonCardModal && (
        <ComparsionModal
          selectComparisonCardModal={selectComparisonCardModal}
          show={showComparisonCardModal}
          handleClose={() => setShowComparisonCardModal(false)}
        />
      )}
    </>
  );
}
